<template>
  <div class="comments-filter">
    <form-group
      v-model="form.module__id"
      select
      label="Módulo"
      id="select-module"
      placeholder="Todos"
      :disabled="!modules.length"
      :options="[{ id: '', name: 'Todos' }, ...modules]"
    />
    <action-dispatcher
      v-if="form.module__id"
      action="membersLessons/get"
      :key="form.module__id"
      :parameters="{ module_id: form.module__id }"
    >
      <form-group
        v-model="form.lesson__id"
        select
        label="Aula"
        id="select-lesson"
        placeholder="Todas"
        :disabled="!lessons.length"
        :options="[{ id: '', name: 'Todas' }, ...lessons]"
      />
    </action-dispatcher>
    <div class="d-flex flex-column flex-lg-row mt-6">
      <button class="btn btn-new-secondary flex-fill mr-lg-3" @click="close">
        Cancelar
      </button>
      <div class="btn btn-new-primary flex-fill ml-lg-3" @click="submit">
        Aplicar
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    value: Object
  },
  data() {
    return {
      form: { ...this.value }
    };
  },
  computed: {
    ...mapState("membersModules", ["modules"]),
    ...mapState("membersLessons", ["lessons"])
  },
  methods: {
    submit() {
      this.$emit("input", this.form);
      this.close();
    },
    close() {
      this.$emit("close");
    }
  },
  watch: {
    "form.module__id"() {
      this.form.lesson__id = "";
    }
  }
};
</script>
